const sortedList = (list) => {
    const newSortedList = Object.entries(list).sort((a, b) => a[1].localeCompare(b[1]));

    return Object.fromEntries(newSortedList);
};

export default sortedList;
